import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { createAttachment } from 'action/article'
import { Tooltip, Form, Button, Modal } from 'antd'
import PropTypes from 'prop-types'
import AttachmentForm from 'view/page/dataset-management/component/attachments/attachment-form'
import FormModal from 'view/component/form-modal'
import { PlusOutlined } from '@ant-design/icons'
import styles from './styles.scss'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.file_name} has been successfully created${response.is_draft ? ' as a draft.' : '.'}`,
  title: 'Attachment created'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const handleSubmit = (createAttachment, form, setVisible, datasetUuid) => async () => {
  try {
    const values = await form.validateFields()

    const response = await createAttachment({ ...values, article_uuid: datasetUuid })
    setVisible(false)
    form.resetFields()
    if (!response.error) {
      success(buildSuccessObject(response))
    } else {
      error(buildErrorObject(response))
    }
  } catch ({ errorFields }) {
    form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO])
  }
}

const NewAttachment = ({ createAttachment, submitting, dataset }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const attachmentPreSets = { category_uuid: dataset.category_uuid, organisation_uuids: dataset.organisation_uuids, sub_category_uuid: dataset.sub_category }
  const handleClick = () => setVisible(true)
  return (
    <>
      {getTooltip(handleClick)}
      <FormModal
        handleSubmit={handleSubmit(createAttachment, form, setVisible, dataset.uuid)}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.resetFields()
        }}
        title='New Attachment'
        visible={visible}
        width='50vw'
      >
        <AttachmentForm
          attachment={attachmentPreSets}
          form={form}
        />
      </FormModal>
    </>
  )
}
const getTooltip = (handleClick) => (
  <Tooltip
    color='#490C4E'
    title='Add Attachment'
  >
    <Button
      className={styles.add_button}
      onClick={handleClick}
      type='primary'
    >
      <PlusOutlined style={{ color: '#490C4E' }} />
    </Button>
  </Tooltip>)

NewAttachment.propTypes = {
  createAttachment: PropTypes.func,
  dataset: PropTypes.object,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.datasetSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  createAttachment: bindActionCreators(createAttachment, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(NewAttachment)
